import Link from "next/link";
import { Stack } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faFacebook,
    faLinkedin,
    faTelegram, faXTwitter,
} from '@fortawesome/free-brands-svg-icons';
import IconStyle from "@/src/components/common/pages/social-icons/mui-custom/icon-style";
import {useEffect, useState} from "react";
import {usePathname} from "next/navigation";

const SocialIcons = (
    {
        url = '',
        title = '',
        direction = 'row',
    }: {
        url?: string,
        title?: string,
        direction?: 'row' | 'column';
    }
) => {
    const pathname = usePathname();
    const [shareUrl, setShareUrl] = useState("");

    useEffect(() => {
        if (typeof window !== "undefined") {
            setShareUrl(`${window.location.origin}${pathname}`);
        }
    }, [pathname]);

    const socialLinks = [
        {
            icon: faFacebook,
            href: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
            label: 'Facebook'
        },
        {
            icon: faXTwitter,
            href: `https://x.com/intent/tweet?url=${shareUrl}`,
            label: 'Twitter'
        },
        {
            icon: faLinkedin,
            href: `https://www.linkedin.com/shareArticle?mini=true&url=${shareUrl}`,
            label: 'LinkedIn'
        },
        {
            icon: faTelegram,
            href: `https://t.me/share/url?url=${shareUrl}`,
            label: 'Telegram'
        }
    ];

    return (
        <Stack
            flexDirection={
                direction === 'row' ? {
                    md: "column",
                    sm: "row",
                    xs: "row"
                } : {
                    md: "row",
                    sm: "row",
                    xs: "row"
                }
            }
            alignItems={"center"}
            justifyContent={"center"}
            gap={.5}
        >
            {
                socialLinks.map(item =>
                    <Link
                        href={item.href}
                        key={item.label}
                        target={"_blank"}
                    >
                        <IconStyle>
                            <FontAwesomeIcon
                                icon={item.icon}
                            />
                        </IconStyle>
                    </Link>
                )
            }
        </Stack>
    )
}

export default SocialIcons;
